import { PageHeader, EmptyState } from "@/components/Layout";

export function Home() {
  return (
    <>
      <PageHeader title="Panoramica" subtitle="Stato dei cicli e delle fasi aperte" />
      <EmptyState
        title="Nessuna fase attiva"
        hint="I riquadri di riepilogo, il calendario dei risultati e le fasi in corso compariranno qui appena apri la prima fase."
      />
    </>
  );
}
